import gql from 'graphql-tag'

export default gql`
mutation createLabel($record: CreateOneLabelInput!) {
  createLabel(record: $record) {
    record {
      _id
      referenceId
      seq
      last
      data
      recipient
      address
      app
      remarks
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/createLabel.js